export default __webpack_public_path__ + "static/media/mobile-app-phone.e54fa717.png";